const formatPointsNumber = (value, n, x) => {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')'
  return value
    ? // eslint-disable-next-line no-bitwise
      value?.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,')
    : 0
}

export default formatPointsNumber
